// src/pages/PaymentSuccessPage.jsx - PROFESYONEL VERSİYON
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { createOrder } from '../services/orderService';
import { useCart } from '../context/CartContext';
import toast from 'react-hot-toast';

export default function PaymentSuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { clearCart } = useCart();
  const [processing, setProcessing] = useState(true);
  const [orderData, setOrderData] = useState(null);
  const hasProcessed = useRef(false);

  useEffect(() => {
    const processOrder = async () => {
      console.log('🚀 PaymentSuccessPage processOrder başladı');

      if (hasProcessed.current) {
        console.log('⚠️ Sipariş zaten işlendi, tekrar işlenmiyor');
        return;
      }

      hasProcessed.current = true;

      try {
        const orderId = searchParams.get('orderId');
        const authCode = searchParams.get('authCode');

        console.log('📥 Ödeme parametreleri:', { orderId, authCode });

        if (!orderId || !authCode) {
          throw new Error('Ödeme bilgileri eksik');
        }

        const pendingOrderData = localStorage.getItem('pendingOrder');
        
        if (!pendingOrderData) {
          console.error('❌ LocalStorage\'da pendingOrder bulunamadı!');
          throw new Error('Sipariş verisi bulunamadı. Lütfen müşteri hizmetleri ile iletişime geçin.');
        }

        const orderDataParsed = JSON.parse(pendingOrderData);
        console.log('📦 Sipariş verisi:', {
          orderId: orderDataParsed.orderId,
          customerType: orderDataParsed.customerType,
          email: orderDataParsed.email,
          total: orderDataParsed.total
        });

        orderDataParsed.paymentStatus = 'paid';
        orderDataParsed.paymentResult = {
          authCode: authCode,
          transactionDate: new Date().toISOString()
        };

        console.log('📝 Sipariş oluşturuluyor...');

        const orderResult = await createOrder(orderDataParsed);

        console.log('📦 createOrder sonucu:', orderResult);

        if (orderResult.success) {
          console.log('✅ Sipariş başarıyla oluşturuldu:', orderResult.orderNumber);
          
          // Sipariş verisini state'e kaydet
          setOrderData({
            orderNumber: orderResult.orderNumber,
            email: orderDataParsed.email,
            total: orderDataParsed.total,
            items: orderDataParsed.items,
            shippingAddress: orderDataParsed.shippingAddress,
            customerType: orderDataParsed.customerType,
            createdAt: new Date().toISOString()
          });

          localStorage.removeItem('pendingOrder');
          console.log('🗑️ pendingOrder temizlendi');

          clearCart();
          console.log('🛒 Sepet temizlendi');

          toast.success('Ödeme başarılı! Siparişiniz oluşturuldu.', {
            duration: 4000,
            icon: '✅'
          });

          setProcessing(false);

        } else {
          throw new Error(orderResult.error || 'Sipariş oluşturulamadı');
        }

      } catch (error) {
        console.error('❌ Sipariş işleme hatası:', error);
        
        toast.error(error.message || 'Sipariş oluşturulurken hata oluştu', {
          duration: 5000
        });

        hasProcessed.current = false;
        setProcessing(false);

        setTimeout(() => {
          navigate('/checkout');
        }, 4000);
      }
    };

    processOrder();
  }, [searchParams, navigate, clearCart]);

  // ✅ Sipariş oluşturulduktan sonra gösterim
  if (!processing && orderData) {
    const isGuest = orderData.customerType === 'guest';
    
    return (
      <OrderSuccessDisplay 
        orderData={orderData} 
        isGuest={isGuest}
        navigate={navigate}
      />
    );
  }

  // ✅ İşlem devam ediyor
  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      flexDirection: 'column',
      gap: '24px',
      padding: '20px',
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
    }}>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>

      <div style={{
        background: '#fff',
        borderRadius: '24px',
        padding: '60px 80px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
        textAlign: 'center',
        maxWidth: '500px'
      }}>
        <div style={{
          width: '60px',
          height: '60px',
          border: '6px solid #f3f3f3',
          borderTop: '6px solid #E5332A',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 32px'
        }}></div>
        
        <h2 style={{
          fontSize: '24px',
          fontWeight: '700',
          color: '#2B2B2B',
          marginBottom: '12px'
        }}>
          Ödemeniz İşleniyor...
        </h2>
        
        <p style={{
          fontSize: '16px',
          color: '#868e96',
          lineHeight: '1.6',
          marginBottom: '24px'
        }}>
          Lütfen bekleyin, siparişiniz oluşturuluyor.
          <br />
          Bu işlem birkaç saniye sürebilir.
        </p>

        <div style={{
          background: '#fff5f5',
          border: '2px solid #ffe0e0',
          borderRadius: '12px',
          padding: '16px',
          fontSize: '14px',
          color: '#495057'
        }}>
          💡 <strong>Not:</strong> Bu sayfayı kapatmayın veya yenilemeyin.
        </div>
      </div>
    </div>
  );
}

// ✅ Sipariş Başarılı Ekranı Component
function OrderSuccessDisplay({ orderData, isGuest, navigate }) {
  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      padding: '20px',
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
    }}>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes scaleIn {
          from { transform: scale(0); }
          to { transform: scale(1); }
        }
        .success-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 14px 28px;
          border-radius: 12px;
          font-weight: 600;
          font-size: 15px;
          cursor: pointer;
          transition: all 0.2s;
          text-decoration: none;
          border: none;
        }
        .primary-btn {
          background: #E5332A;
          color: #fff;
          width: 100%;
        }
        .primary-btn:hover {
          background: #c72a22;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(229, 51, 42, 0.3);
        }
        .secondary-btn {
          background: #fff;
          color: #2B2B2B;
          border: 2px solid #e9ecef;
          width: 100%;
        }
        .secondary-btn:hover {
          border-color: #E5332A;
          color: #E5332A;
          transform: translateY(-2px);
        }
      `}</style>

      <div style={{
        background: '#fff',
        borderRadius: '24px',
        padding: '48px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
        textAlign: 'center',
        maxWidth: '600px',
        width: '100%',
        animation: 'fadeIn 0.5s ease-out'
      }}>
        {/* Başarı İkonu */}
        <div style={{ 
          fontSize: '80px',
          marginBottom: '24px',
          animation: 'scaleIn 0.5s ease-out'
        }}>
          ✅
        </div>
        
        {/* Başlık */}
        <h1 style={{
          fontSize: '32px',
          fontWeight: '700',
          color: '#16a34a',
          marginBottom: '16px'
        }}>
          Siparişiniz Alındı!
        </h1>
        
        {/* Sipariş Numarası */}
        <div style={{
          background: 'linear-gradient(135deg, #E5332A 0%, #c72a22 100%)',
          padding: '24px 32px',
          borderRadius: '16px',
          marginBottom: '32px',
          boxShadow: '0 8px 24px rgba(229, 51, 42, 0.2)'
        }}>
          <div style={{
            fontSize: '13px',
            color: 'rgba(255,255,255,0.9)',
            marginBottom: '8px',
            fontWeight: '500',
            letterSpacing: '1px',
            textTransform: 'uppercase'
          }}>
            Sipariş Numaranız
          </div>
          <div style={{
            fontSize: '28px',
            fontWeight: '800',
            color: '#fff',
            letterSpacing: '2px',
            fontFamily: 'monospace'
          }}>
            {orderData.orderNumber}
          </div>
        </div>
        
        {/* Bilgilendirme Mesajı */}
        <div style={{
          background: '#f0f9ff',
          border: '2px solid #bfdbfe',
          borderRadius: '16px',
          padding: '20px',
          marginBottom: '32px',
          textAlign: 'left'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '12px',
            marginBottom: '12px'
          }}>
            <span style={{ fontSize: '24px' }}>📧</span>
            <div>
              <h3 style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#1e3a8a',
                marginBottom: '8px'
              }}>
                Sipariş Onayı E-posta Adresinize Gönderildi
              </h3>
              <p style={{
                fontSize: '14px',
                color: '#475569',
                lineHeight: '1.6',
                margin: 0
              }}>
                <strong>{orderData.email}</strong> adresine sipariş detaylarınızı gönderdik.
              </p>
            </div>
          </div>
          
          {isGuest && (
            <div style={{
              background: '#fff',
              borderRadius: '12px',
              padding: '16px',
              marginTop: '16px',
              border: '1px solid #e0f2fe'
            }}>
              <p style={{
                fontSize: '14px',
                color: '#475569',
                lineHeight: '1.6',
                margin: 0
              }}>
                💡 <strong>İpucu:</strong> Sipariş numaranızı not alın. Daha sonra siparişinizi takip etmek için sipariş numarası ve e-posta adresiniz gerekecek.
              </p>
            </div>
          )}
        </div>

        {/* Sipariş Özeti */}
        <div style={{
          background: '#f8f9fa',
          borderRadius: '16px',
          padding: '20px',
          marginBottom: '32px',
          textAlign: 'left'
        }}>
          <h3 style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#2B2B2B',
            marginBottom: '16px'
          }}>
            Sipariş Özeti
          </h3>
          
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            marginBottom: '8px'
          }}>
            <span style={{ color: '#868e96' }}>Ürün Sayısı:</span>
            <strong>{orderData.items.length} ürün</strong>
          </div>
          
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            marginBottom: '8px'
          }}>
            <span style={{ color: '#868e96' }}>Teslimat Adresi:</span>
            <strong>{orderData.shippingAddress.city}</strong>
          </div>
          
          <div style={{
            borderTop: '2px solid #e9ecef',
            marginTop: '12px',
            paddingTop: '12px',
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '16px'
          }}>
            <span style={{ fontWeight: '600' }}>Toplam:</span>
            <strong style={{ color: '#E5332A', fontSize: '20px' }}>
              {orderData.total.toFixed(2)}₺
            </strong>
          </div>
        </div>

        {/* Aksiyonlar */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {isGuest ? (
            <>
              <button 
                className="success-btn primary-btn"
                onClick={() => navigate('/order-tracking')}
              >
                📦 Siparişimi Takip Et
              </button>
              <button 
                className="success-btn secondary-btn"
                onClick={() => navigate('/')}
              >
                🏠 Alışverişe Devam Et
              </button>
            </>
          ) : (
            <>
              <button 
                className="success-btn primary-btn"
                onClick={() => navigate('/orders')}
              >
                📋 Siparişlerim
              </button>
              <button 
                className="success-btn secondary-btn"
                onClick={() => navigate('/')}
              >
                🏠 Alışverişe Devam Et
              </button>
            </>
          )}
        </div>

        {/* Ek Bilgilendirme */}
        <div style={{
          marginTop: '32px',
          paddingTop: '24px',
          borderTop: '1px solid #e9ecef',
          display: 'flex',
          justifyContent: 'center',
          gap: '32px',
          fontSize: '13px',
          color: '#868e96'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span>🚚</span>
            <span>2-3 iş günü</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span>🛡️</span>
            <span>Güvenli ödeme</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span>↩️</span>
            <span>7 gün iade</span>
          </div>
        </div>
      </div>
    </div>
  );
}